import { render, staticRenderFns } from "./dataModification.vue?vue&type=template&id=6910591f&scoped=true&"
import script from "./dataModification.vue?vue&type=script&lang=js&"
export * from "./dataModification.vue?vue&type=script&lang=js&"
import style0 from "./dataModification.vue?vue&type=style&index=0&id=6910591f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6910591f",
  null
  
)

export default component.exports